/*
 *
 * CustomIndicators constants
 *
 */
export const GET_SURVEY_TYPES_WATCHER =
  "app/CustomIndicators/GET_SURVEY_TYPES_WATCHER"
export const GET_SURVEY_TYPES_SUCCESS =
  "app/CustomIndicators/GET_SURVEY_TYPES_SUCCESS"
export const GET_SURVEY_TYPES_FAILED =
  "app/CustomIndicators/GET_SURVEY_TYPES_FAILED"

export const GET_SWITCH_SURVEY_TYPES_WATCHER =
  "app/CustomIndicators/GET_SWITCH_SURVEY_TYPES_WATCHER"
export const GET_SWITCH_SURVEY_TYPES_SUCCESS =
  "app/CustomIndicators/GET_SWITCH_SURVEY_TYPES_SUCCESS"
export const GET_SWITCH_SURVEY_TYPES_FAILED =
  "app/CustomIndicators/GET_SWITCH_SURVEY_TYPES_FAILED"
